<im-radio-group
  [items]="items()"
  itemClass="contract-radio"
  [ngModel]="null"
  (ngModelChange)="onContractSelected($event)"
>
  <ng-template let-item>
    <div class="d-flex flex-column flex-sm-row justify-content-between flex-grow-1">
      <div class="d-flex align-items-center">
        <div class="me-2">
          <rs-web-icon [icon]="item.contract.type | contractIcon" [size]="15"></rs-web-icon>
        </div>
        <div class="text-break">
          {{ item.contract.property.address | address }}
        </div>
      </div>
      <div class="text-break mt-1 mt-sm-0">
        {{ item.contract.externalId }}
      </div>
    </div>
  </ng-template>
</im-radio-group>
